import React from "react";
import carelogo from "../assets/img/carelogo.jpeg"
import { Link } from "react-router-dom";

export const Header = () => {
  return (
    <div>
              {/* <!-- Spinner Start --> */}
        {/* <div id="spinner" className="show w-100 vh-100 bg-white position-fixed translate-middle top-50 start-50 d-flex align-items-center justify-content-center">
            <div className="spinner-grow text-primary" role="status"></div>
        </div> */}
        {/* <!-- Spinner End --> */}

        {/* <!-- Topbar Start --> */}
        <div className="container-fluid topbar-top bg-primary">
            <div className="container">
                <div className="d-flex justify-content-between topbar py-2">
                    <div className="d-flex align-items-center flex-shrink-0 topbar-info">
                        <a href="#" className="me-4 text-light"><i className="fas fa-map-marker-alt me-2 text-light"></i>7-Jinnah Stadium, Okara</a>
                        <a href="#" className="me-4 text-light"><i className="fas fa-phone-alt me-2 text-light"></i>+92 301-7332100</a>
                        <a href="#" className="text-light"><i className="fas fa-envelope me-2 text-light"></i>carefoudnation.ok@gmail.com</a>
                    </div>

                    <div className="d-flex align-items-center justify-content-center topbar-icon">
                        <a href="#" className="me-4"><i className="fab fa-facebook-f text-light"></i></a>
                        <a href="#" className="me-4"><i className="fab fa-twitter text-light"></i></a>
                        <a href="#" className="me-4"><i className="fab fa-instagram text-light"></i></a>
                        <a href="#" className=""><i className="fab fa-linkedin-in text-light"></i></a>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Topbar End --> */}


        {/* <!-- Navbar Start --> */}
        <div className="container-fluid">
            <div className="container">
                <nav className="navbar navbar-dark navbar-expand-lg py-lg-0">
                    <Link to="/" className="navbar-brand">
                        <h3 className="text-primary mb-0"><img src={carelogo} style={{width: "90px"}}/> Care Foundation</h3>
                    </Link>
                    <button className="navbar-toggler bg-primary" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                        <span className="fa fa-bars text-dark"></span>
                    </button>
                    <div className="collapse navbar-collapse me-n3" id="navbarCollapse">
                        <div className="navbar-nav ms-auto">
                            <Link to='/' className="nav-item nav-link text-dark  active"><b>Home</b></Link>
                            <Link to="about" className="nav-item nav-link text-dark"><b>About</b></Link>
                            <Link to="services" className="nav-item nav-link text-dark"><b>Services</b></Link>
                            <Link to="projects" className="nav-item nav-link text-dark"><b>Projects</b></Link>
                            <Link to="events" className="nav-link text-dark" ><b>Events</b></Link>
                            <Link to="contact" className="nav-item nav-link text-dark"><b>Contact</b></Link>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        {/* <!-- Navbar End --> */}
    </div>
  );
};